import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Loading from '@dynapp/wc-api-loading';
import DyncPopovers from 'dync-popovers';
import DyncBooking from 'dync-booking';


Vue.config.productionTip = false;
Vue.use(Loading, {store});
Vue.use(DyncBooking, {store, dataObject: 'dync-appshop-web', admin: true});
Vue.use(DyncPopovers, {vuetify});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
